<template>

  <div style="margin-top: 24px;">

    <div style="margin-bottom: 12px;">
      <h5 style="margin-bottom: 6px;"><lang :labelKey="`LOYALTYCARD-MULTIPLIER-TITLE`"></lang></h5>
      <lang labelKey="LOYALTYCARD-MULTIPLIER-DESRIPTION" style="white-space: normal !important;"></lang>
    </div>
    
    <!-- show loading indicator -->
	  <loading-indicator :loading="isLoadingOptions" style="max-height: 150px;"></loading-indicator>

    <div v-if="!isLoadingOptions" class="multipliers">
      
      <div v-if="multiplierData && multiplierData.length == 0">
        <i>Keine Multiplier vorhanden</i>
      </div>

      <div v-for="multiplier in multipliersData" :key="multiplier.object_id" class="item-multiplier">
                      
        <div class="type">
          <lang :labelKey="`LOYALTYCARD-MULTIPLIER-TYPE-${multiplier.type}`" class="label"></lang>
        </div>

        
        <div class="description">

          <span v-html="multiplier.name"></span>
          
          <template v-if="multiplier.type === 'PRODUCT'">

          </template>

          <template v-if="multiplier.type === 'BRAND'">
   
          </template>

          <template v-if="multiplier.type === 'CAT'">
   
          </template> 

          <template v-if="multiplier.type === 'GROUP' && multiplier.description">
           <br><i>{{ multiplier.description }}</i>
          </template>

        </div>

        <div class="multiplier">
          <input type="number" v-model="multiplier.multiplier" min="0" step="0.10">
        </div>


        <div class="remove">

          <pop-confirm class="button is-small"
          content="Sind Sie sicher, dass Sie diesen Multiplier entfernen möchten?" icon="question-circle-o"
          :on-ok="function () {
            removeMultiplier(multiplier);
          }
          " cancel-text="nein">
            <span class="icon is-small" title="Aktion löschen">
              <i class="icon-ak-entfernen"></i>
            </span>
          </pop-confirm>
          
        </div>

      </div>

      <button class="button is-blue is-outline" style="margin-left: auto" @click="showAddMultiplierModal = true">
        <lang :labelKey="`LOYALTYCARD-MULTIPLIER-ADD_MULTIPLIER`"></lang>
      </button>


    
      <modal
        :title="$t('LOYALTYCARD-MULTIPLIER-ADD_MULTIPLIER-MODAL-TITLE')"
        :is-show="showAddMultiplierModal"
        :backdrop-closable="false"
        :show-footer="true"
        ok-text="übernehmen"
        :on-ok="function () { addMultiplier() }"
        :on-cancel="function () { closeModalAddMultiplier() }"
        cancel-text="abbrechen"
        class="vcenter">

        <div style="max-width: 450px; margin: 0 auto; text-align: center;">

          <!-- Typ-Auswahl -->
          <form-input 
            v-model="addMultiplierSelection.type" 
            selectFieldName="label"
            inputType="select" 
            label="LOYALTYCARD-MULTIPLIER-SELECT_TYPE" 
            :showLabelInOptions="false"
            :selectOptions="selectOptions">
          </form-input>



          <template v-if="addMultiplierSelection.type">

            <!-- CATEGORY -->
            <div class="control" v-if="addMultiplierSelection.type.value === 'CAT'">
              <div class="control-label">
                <lang labelKey="PIM-CAMPAIGN-PRODUCT_CATEGORIES" class="label"></lang>
              </div>
              <div class="control">
                <treeselect
                  v-model="addMultiplierSelection.data"
                  placeholder="bitte Kategorie auswählen"
                  :multiple="false"
                  :loading="options.categories == null"
                  :options="options.categories"
                  :normalizer="normalizeCategories"
                  value-consists-of="ALL">
                </treeselect>
              </div>
            </div>

            <!-- GROUP -->
            <div class="control" v-if="addMultiplierSelection.type.value === 'GROUP'">

                <div class="control-label">
                    <lang labelKey="PIM-CAMPAIGN-CUSTOM_PRODUCT_GROUPS" class="label"></lang>
                </div>

                <div class="control">


                    <multiselect
                        v-if="options.groups != null"
                        v-model="groupIdWrapper"
                        :options="options.groups"
                        :custom-label="function({ name }) { return name; }"
                        :allow-empty="true"
                        :multiple="false"
                        selected-label="aktiv"
                        deselect-label="Klick um abzuwählen"
                        select-label="Klick für Auswahl"
                        placeholder="Bitte Gruppe auswählen"
                        label="name"
                        track-by="id"
                        :optionsLimit="10"
                        class="small">

                        <span slot="noOptions">Keine Einträge vorhanden</span>
                        <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>

                    </multiselect>

                </div>

            </div>

            <!-- BRAND -->
            <div class="control" v-if="addMultiplierSelection.type.value === 'BRAND'">
              <div class="control-label">
                <lang labelKey="PIM-CAMPAIGN-BRANDS" class="label"></lang>
              </div>
              <div class="control">
                <multiselect
                  v-model="brandIdWrapper"
                  :options="options.brands"
                  :custom-label="({ name }) => name"
                  :allow-empty="true"
                  :multiple="false"
                  selected-label="aktiv"
                  deselect-label="Klick um abzuwählen"
                  select-label="Klick für Auswahl"
                  placeholder="Bitte Marke auswählen"
                  label="name"
                  track-by="id"
                  :optionsLimit="10"
                  :loading="options.brands == null"
                  class="small">
                  <span slot="noOptions">Keine Einträge vorhanden</span>
                  <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>
                </multiselect>
              </div>
            </div>

            <!-- PRODUCT -->
            <div class="control" v-if="addMultiplierSelection.type.value === 'PRODUCT'" :key="addMultiplierSelection.data">

              <div v-if="this.addMultiplierSelection.data != null" style="display:flex; padding: 6px 8px; border-radius: 4px; background-color: #F5F5F5">
                <div>
                  <span v-html="addMultiplierSelection.data.name"></span>
                </div>
                <div style="margin-left: auto;">
                  <span class="icon is-small has-pointer" style="vertical-align: middle" title="Produkt entfernen"  @click="addMultiplierSelection.data = null">
                    <i class="icon-ak-entfernen"></i>
                  </span>
                </div>

              </div>

              <template v-else>
                <button class="button" @click="showPimModal = true">Produkt auswählen</button>
              </template>


            </div>
            
              
            <!-- Multiplier Input -->
            <form-input label="LOYALTYCARD-MULTIPLIER-VALUE" :isPointToComma="true" :showInfoText="false" inputType="text"
              v-model="addMultiplierSelection.multiplier" :is-horizontal="false">
            </form-input>
            
          </template> 

        </div>

      </modal>

      <modal
          title="Produkte"
          transition="fadeDown"
          :is-show="showPimModal"
          :backdrop-closable="false"
          :show-footer="true"
          @close="showPimModal = false"
          class="vcenter pimModal">

 <!--:preselectedProducts = " .products.map(_ => parseInt(_.pimProduct.id))"
 :showFilters = "['filterPackageLeaflet', 'filterCategory', 'filterIncomplete', 'filterMultiple', 'filterVariableProduct', 'filterIsDrug', 'filterImage']"
                  -->
            <pim-products
              v-if="showPimModal"
              :allowSelection="false"
              :allowDelete="false"
              :allowEditName="false"
              :allowEditProduct="false"
              :showPharmacyFilter="false"
              :showPagination="false"
              :showFilters = "[]"
              :singleSelectOnly="true"
                  
              @selectedRows="selectProduct">
            </pim-products>

            <template slot="footer">
              <a class="button" @click.prevent.parent="showPimModal = false">Abbrechen</a>
              <a :class="['button is-primary', { 'is-disabled': this.addMultiplierSelection.data == null }]" @click.prevent.parent="assignProduct">Übernehmen</a>
            </template>

      </modal>

    </div>
  </div>
</template>



<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import pimProducts from '/src/components/pim/incl-pimProducts';
export default {

  name: 'pwaConfigLoyaltyCardMultipliers',

  components: {
    pimProducts,
    Treeselect
  },

  props: {

    site: {
      type: Object,
      default: () => { }
    },

  },


  data() {

    return {
      isLoadingOptions: false,
      options: {
        groups: null,
        categories: null,
        brands: null,
        // customerGroups: null
      },

      showAddMultiplierModal: false,
      showPimModal: false,

      multipliers: [],
      multipliersData: [],

      categoryIds: [],

      addMultiplierSelection: {
        type: null,
        multiplier: 0,
        data: null
      }

      
    }

  },

  created() {

    if(this.site.loyaltyCard) {
      this.fetchOptions();
    }

  },

  watch: {
    'site.loyaltyCard': {
      handler(newVal) {
        if (newVal) {
          this.fetchOptions();
        }
      },
    }
  },

  computed: {

    selectOptions() {
      return [
        { label: 'Gruppe', value: 'GROUP' },
        { label: 'Kategorie', value: 'CAT' },
        { label: 'Marke', value: 'BRAND' },
        { label: 'Produkt', value: 'PRODUCT' }
      ];
    },

    brandIdWrapper: {

      get() {
        if(this.options.brands == null) {
            return null;
        }
        return this.addMultiplierSelection.data;
      },

      set(val) {
        this.addMultiplierSelection.data = val;
      }

    },
    
    groupIdWrapper: {

        get() {
            if(this.options.groups == null) {
                return null;
            }
            return this.addMultiplierSelection.data;
        },

        set(val) {
            this.addMultiplierSelection.data = val;
        }

    },


  },

  methods: {

    addMultiplier() {

      // check if all fields are filled
      if(!this.addMultiplierSelection.type || this.addMultiplierSelection.multiplier == null || !this.addMultiplierSelection.data) {
        this.$notify.open({ content: 'Bitte alle Felder ausfüllen!', type: 'warning' });
        return;
      }

      // check if multiplier is a valid float
      const multiplierValue = parseFloat(this.addMultiplierSelection.multiplier);
      if (isNaN(multiplierValue)) {
        this.$notify.open({ content: 'Multiplier muss eine gültige Zahl sein!', type: 'warning' });
        return;
      }
      this.addMultiplierSelection.multiplier = multiplierValue;

      let multiplierObj = {
        type: this.addMultiplierSelection.type.value,
        multiplier: this.addMultiplierSelection.multiplier,
        site: this.site.siteId,
      }

      // handle BRAND selection
      if(this.addMultiplierSelection.type.value === 'BRAND') {
          multiplierObj.name = this.addMultiplierSelection.data.name;
          multiplierObj.objectId = this.addMultiplierSelection.data.id;
      }


      // handle CATEGORY selection
      else if(this.addMultiplierSelection.type.value === 'CAT') {

        function findCategoryById(categories, id) {
          for (const cat of categories) {
            if (cat.id === id) {
              return cat;
            }
            if (cat.children && cat.children.length > 0) {
              const found = findCategoryById(cat.children, id);
              if (found) return found;
            }
          }
          return null;
        }

        const foundCategory = findCategoryById(this.options.categories, this.addMultiplierSelection.data);
        if (foundCategory) {
          multiplierObj.name = foundCategory.name;
          multiplierObj.objectId = foundCategory.id;
        }

      }

      // handle GROUP selection
      else if(this.addMultiplierSelection.type.value === 'GROUP') {
        multiplierObj.name = this.addMultiplierSelection.data.name;
        multiplierObj.description = this.addMultiplierSelection.data.description;
        multiplierObj.objectId = this.addMultiplierSelection.data.id;
      }

      // handle PRODUCT selection
      else if(this.addMultiplierSelection.type.value === 'PRODUCT') {
        multiplierObj.name = this.addMultiplierSelection.data.name;
        multiplierObj.objectId = this.addMultiplierSelection.data.id;
      }

      this.multipliersData.push(multiplierObj);
      this.$emit('update:multipliers-data', this.multipliersData);

      // this.$forceUpdate();
      this.closeModalAddMultiplier();
      
    },

    
    removeMultiplier(item) {
      
      const index = this.multipliersData.findIndex(m => m.object_id === item.object_id);
      if (index !== -1) {
        this.multipliersData.splice(index, 1);
      }
      
      this.$emit('update:multipliers-data', this.multipliersData);
    },
    
    closeModalAddMultiplier() {
      this.showAddMultiplierModal = false;
      this.addMultiplierSelection = {
        type: null,
        multiplier: 0,
        data: null
      }
    },


    assignProduct() {
        // console.log("--> assign product: ", this.addMultiplierSelection.data);
        this.addMultiplierSelection.data.name = this.addMultiplierSelection.data.name + ' <i>(PZN ' + this.addMultiplierSelection.data.extRef + ')</i>';
        this.$forceUpdate();
        this.showPimModal = false;

    },

    selectProduct(product) {
      if(product) {
        this.addMultiplierSelection.data = product[0];
      }
    },

    normalizeCategories(node) {

      return {
          id: node.id,
          label: node.name,
          children: node.children
      }

    },

    _loadBrands() {
        return this.axios.get(this.$config.api + 'pimBrand?orderBy=name&filters[name]=!');
    },

    _loadGroups() {
        return this.axios.get(this.$config.api + 'apopointProductGroup?include=apopointProductGroup.products&filters[site]='+this.site.siteId);
    },

    _loadCategories() {
        return this.axios.get(this.$config.api + 'pimCategory/tree?site='+this.site.siteId);
    },
    /*
    _loadCustomerGroups() {
        return this.axios.get(this.$config.api + 'apopointCustomerGroup');
    },
    */

    _loadSiteLoyaltyPointMultiplier() {
        return this.axios.get(this.$config.api + 'siteLoyaltyPointMultiplier?filters[site]='+this.site.siteId);
    },

    async fetchOptions() {

      this.isLoadingOptions = true;

      await this._loadSiteLoyaltyPointMultiplier().then(res => {
        this.multipliers = res.data.siteLoyaltyPointMultiplier;
      })

      await this._loadGroups().then(res => {
          this.options.groups = res.data.apopointProductGroup;
      })

      await this._loadCategories().then(res => {
        this.options.categories = res.data;
      })

      await this._loadBrands().then(res => {
          this.options.brands = res.data.pimBrand;
      })
      /*
      await this._loadCustomerGroups().then(res => {
          this.options.customerGroups = res.data.apopointCustomerGroup;
      })  
      */

      if(this.multipliers) {


        
        //---------------------------------------------------------------
        // PRODUCTS
        //---------------------------------------------------------------
        const products = this.multipliers.filter(m => m.type === 'PRODUCT');

        // for each product, make a request and store the desired fields
        await Promise.all(products.map(async (product) => {
          try {
            // ${product.id}
            const res = await this.axios.get(this.$config.api + `pimProduct/${product.objectId}?include=pimProduct.assets`);
            const prod = res.data;
            this.multipliersData.push({
              id: product.id,
              name: prod.name + ' <i>(PZN ' + prod.extRef + ')</i>',
              thumbUrl: prod.assets && prod.assets.length > 0 ? prod.assets[0].thumbUrl : null,
              type: product.type,
              objectId: prod.id,
              multiplier: product.multiplier,
              site: this.site.siteId
            });
          } catch (e) {

            console.error('Fehler beim Laden des Produkts:', product.id, e);
          }
        }));

        //---------------------------------------------------------------
        // BRANDS
        //---------------------------------------------------------------
        const brands = this.multipliers.filter(m => m.type === 'BRAND');
        this.options.brands.forEach(brand => {
          const matchedBrand = brands.find(b => b.objectId === brand.id);
          if (matchedBrand) {
            this.multipliersData.push({
              id: matchedBrand.id,
              name: brand.name,
              type: 'BRAND',
              objectId: brand.id,
              multiplier: matchedBrand.multiplier,
              site: this.site.siteId
            });
          }
        });

        //---------------------------------------------------------------
        // CATEGORIES
        //---------------------------------------------------------------
        const categories = this.multipliers.filter(m => m.type === 'CAT');

        function traverseCategories(categories, callback) {
          categories.forEach(category => {
            callback(category);
            if (category.children && category.children.length > 0) {
              traverseCategories(category.children, callback);
            }
          });
        }

        traverseCategories(this.options.categories, (category) => {
          const matchedCategory = categories.find(c => c.objectId === category.id);
          if (matchedCategory) {
            this.multipliersData.push({
              id: matchedCategory.id,
              name: category.name,
              type: 'CAT',
              objectId: category.id,
              multiplier: matchedCategory.multiplier,
              site: this.site.siteId
            });
          }
        });

        //---------------------------------------------------------------
        // CUSTOMER GROUPS
        //---------------------------------------------------------------


        const groups = this.multipliers.filter(m => m.type === 'GROUP');
        this.options.groups.forEach(group => {

          const matchedGroup = groups.find(g => g.objectId === group.id);

          if (matchedGroup) {
            this.multipliersData.push({
              id: matchedGroup.id,
              name: group.name,
              description: group.description,
              type: 'GROUP',
              objectId: group.id,
              multiplier: matchedGroup.multiplier,
              site: this.site.siteId
            });
          }
        });

      }

      // make sure to emit the updated multipliers data
      this.$emit('update:multipliers-data', this.multipliersData);

      this.isLoadingOptions = false;
    }
  }

}

</script>

<style lang="scss" scoped>






::v-deep .vue-treeselect__multi-value-item {
    color: #000;
    background: #F5F7F9;
}
::v-deep .vue-treeselect__value-remove {
    color: #aaa;
}


.multipliers {

  max-width: 800px;

  .item-multiplier {

    display: flex;
    padding: 12px;
    border-radius: 4px;
    background-color: #FFF;
    margin-bottom: 8px;
    align-items: center;
    gap: 16px;

    .type {
      font-weight: bold;
      width: 100px;
      font-size: 12px;
    }
    > :not(.type, .remove, .multiplier) {
      flex: 1 1 0;
    }

    .remove {
   
      margin-left:auto;
      text-align: right;
    }

    .multiplier {
      margin-left:auto;
      text-align: right;

      input {
        cursor: pointer;
        min-width: 70px;
        max-width: 85px;
        border: none;
        outline: none;
        padding: 6px;
        text-align:right;

        &:focus {
          outline: none;
          background-color: #f5f5f5;
          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);
        }
      }
    }
  }
  
}
    .pimModal {

        ::v-deep .modal-card {
            min-width: 640px;
            max-width: 90%;
            width: 100%;
            max-height: 95vh;
            overflow: hidden;
        }

    }
</style>
